var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripRouteIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_73709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 1.66675C16.8039 1.66675 18.3333 3.17911 18.3333 5.01391C18.3333 6.87792 16.779 8.18601 15.3433 9.0755C15.2387 9.13533 15.1204 9.16675 15 9.16675C14.8796 9.16675 14.7613 9.13533 14.6567 9.0755C13.2237 8.17733 11.6667 6.88437 11.6667 5.01391C11.6667 3.17911 13.1961 1.66675 15 1.66675Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5H15.006",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16666 18.3333C5.54737 18.3333 6.66666 17.214 6.66666 15.8333C6.66666 14.4525 5.54737 13.3333 4.16666 13.3333C2.78594 13.3333 1.66666 14.4525 1.66666 15.8333C1.66666 17.214 2.78594 18.3333 4.16666 18.3333Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 5.83325H7.91667C6.30583 5.83325 5 6.95254 5 8.33325C5 9.714 6.30583 10.8333 7.91667 10.8333H10.4167C12.0275 10.8333 13.3333 11.9525 13.3333 13.3333C13.3333 14.714 12.0275 15.8333 10.4167 15.8333H9.16667",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_73709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripRouteIc);
export default __webpack_public_path__ + "static/media/trip_route_ic.d6b5f2488bd95d89ba9c64da3af090c5.svg";
export { ForwardRef as ReactComponent };